import http from "../../core/services/http.service";
import {AppSettings} from "@/shared/AppSettings";

const AttachmentService = {
  createAttachments(formData, onUploadProgress, moduleName) {
    return http.post(AppSettings.getUrl(`/api/v1/${moduleName}/attachments/?expand=created_by`), formData, {
      headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress
    });
  },
  deleteAttachment(uuid, moduleName) {
    return http.delete(AppSettings.getUrl(`/api/v1/${moduleName}/attachments/${uuid}/`));
  }
}

export default AttachmentService;